// extracted by mini-css-extract-plugin
module.exports = {"window":"ErrorMessageWindow_window__2xHhU","imgAndText":"ErrorMessageWindow_imgAndText__3dD7w","image":"ErrorMessageWindow_image__20p9i","text":"ErrorMessageWindow_text__1LK_o"};